import { Serializer } from 'survey-core';

// Constants for validation
const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes
const ALLOWED_CONTENT_TYPES = [
  'image/*', // For IDs, licenses, and scanned documents
  'application/pdf', // Most common format for official documents
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/msword', // .doc
  'application/vnd.ms-excel', // .xls
  'text/csv', // For financial data
  'application/rtf', // Rich text format
];

export const setFileUploadFieldValues = () => {
  // Set the default values for relevant file properties.
  Serializer.getProperty('file', 'storeDataAsText').defaultValue = false;
  Serializer.getProperty('file', 'waitForUpload').defaultValue = true;
  Serializer.getProperty('file', 'maxSize').defaultValue = MAX_FILE_SIZE;
  Serializer.getProperty('file', 'acceptedTypes').defaultValue = ALLOWED_CONTENT_TYPES;
  Serializer.getProperty('file', 'showPreview').defaultValue = false;

  // Setting default values does not update explicitly defined properties
  //   but is still required for the step below to work.
  // onSetValue can be used to update explicitly defined properties.
  Serializer.getProperty('file', 'storeDataAsText').onSetValue = (obj, _value) => {
    obj.setPropertyValue('storeDataAsText', false);
  };
  Serializer.getProperty('file', 'waitForUpload').onSetValue = (obj, _value) => {
    obj.setPropertyValue('waitForUpload', true);
  };
  Serializer.getProperty('file', 'maxSize').onSetValue = (obj, _value) => {
    obj.setPropertyValue('maxSize', MAX_FILE_SIZE);
  };
  Serializer.getProperty('file', 'acceptedTypes').onSetValue = (obj, _value) => {
    obj.setPropertyValue('acceptedTypes', ALLOWED_CONTENT_TYPES);
  };
  Serializer.getProperty('file', 'showPreview').onSetValue = (obj, _value) => {
    obj.setPropertyValue('showPreview', false);
  };
};
